module.exports = __webpack_public_path__ + "img/map libraries.9bf1a83a.png";